<template>
    <div id="app" class="app" data-server-rendered="true">
        <div class="app-container" v-if="isAuthenticated">
            <div class="wrapper" v-if="config && user">
                <div class="wrapper-top">
                    <main-header/>
                    <breadcrumbs/>
                    <transition name="component-fade" mode="out-in">
                        <router-view :key="$route.path"/>
                    </transition>
                </div>
                <div class="wrapper-bottom">
                    <main-footer/>
                </div>
            </div>
        </div>
        <div class="app-container" v-else>
            <div class="wrapper" v-if="config">
                <div class="wrapper-top">
                    <main-header/>
                    <breadcrumbs/>
                    <transition name="component-fade" mode="out-in">
                        <router-view :key="$route.path"/>
                    </transition>
                </div>
                <div class="wrapper-bottom">
                    <main-footer/>
                </div>
            </div>
        </div>
        <hidden/>
        <div class="global-loader" v-show="globalLoader">
            <loader></loader>
        </div>
    </div>
</template>

<style src="@/assets/scss/main.scss" lang="scss"></style>

<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex';
    import MainHeader from '@/components/header/index.vue';
    import MainFooter from '@/components/footer/index.vue';
    import Hidden from '@/components/hidden/index.vue';
    import Breadcrumbs from '@/components/breadcrumbs/index.vue';

    import {
        GET_CATEGORIES_MENU,
        GET_CONFIG,
        GET_CONTACTS,
        FETCH_USER_DATA
    } from '@/store/action-types';

    import {
        CHANGE_POPUP_NEW_PASSWORD,
        FRESH_BASKET_ITEMS
    } from '@/store/mutation-types';

    import { isMobile, isIPad } from '@/helpers/variables/index'



    export default {
        name: 'app',
        components: {
            Breadcrumbs,
            MainHeader,
            MainFooter,
            Hidden,
        },
        computed: {
            ...mapGetters({
                globalLoader: 'system/globalLoader',
                config: 'setting/menu',
                user: 'profile/user',
                isAuthenticated: `auth/isAuthenticated`,
            })
        },
        created() {
            this.fetchMenu();
            this.fetchConfig();
            this.fetchContacts();
            if(this.$route.fullPath.includes('setNewPassword')){
                this.changePopupNewPassword(true);
            }
            if(!localStorage.getItem('favoritesList')){
                localStorage.setItem('favoritesList', '[]');
            }
            if(!localStorage.getItem('showLdapWarning')){
                localStorage.setItem('showLdapWarning', '0');
            }
            if(!localStorage.getItem('products')){
                localStorage.setItem('products', '[]');
            }else{
                if(localStorage.getItem('products').length > 10){
                    this.freshBasket();
                }
            }
            if(this.isAuthenticated){
                this.fetchUser();
            }
        },
        mounted() {
            if(!isMobile.any()) {
                document.querySelector('body').classList.add('hover');
            }
            if(!isIPad.iOS()) {
                document.querySelector('body').classList.add('iPad');
            }
        },
        methods: {
            ...mapMutations({
                changePopupNewPassword: `auth/${CHANGE_POPUP_NEW_PASSWORD}`,
                freshBasket: `basket/${FRESH_BASKET_ITEMS}`,
            }),
            ...mapActions({
                fetchUser: `profile/${FETCH_USER_DATA}`,
                fetchMenu: `setting/${GET_CATEGORIES_MENU}`,
                fetchConfig: `setting/${GET_CONFIG}`,
                fetchContacts: `contacts/${GET_CONTACTS}`,
            }),
        }
    }
</script>
